// src/pages/ResetPassword.jsx
import React from 'react';
import { useForm } from 'react-hook-form';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../infra/apiConfig';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();

  const { register, handleSubmit, watch, formState: { errors, isSubmitting } } = useForm();
  const password = watch('password', '');

  const onSubmit = async (data) => {
    if (!token) {
      alert('Token ausente. Verifique o link recebido por e-mail.');
      return;
    }
    try {
      // Ajuste o endpoint conforme seu backend: aqui usei /resetar-senha
      await axios.post(`${API_BASE_URL}/resetar-senha`, {
        token,
        password: data.password,
      });
      alert('Senha alterada com sucesso. Faça o login com a nova senha.');
      navigate('/');
    } catch (err) {
      console.error(err);
      const message = err.response?.data?.error || 'Não foi possível resetar a senha.';
      alert(message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 p-4">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow">
        <h2 className="text-2xl font-bold mb-2">Criar nova senha</h2>
        {!token ? (
          <div className="text-sm text-red-600 mb-4">
            Link inválido ou token ausente. Peça um novo e-mail de recuperação.
            <div className="mt-2"><Link to="/recuperar-senha" className="text-blue-600">Pedir novo link</Link></div>
          </div>
        ) : (
          <>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Nova senha</label>
                <input
                  type="password"
                  className={`mt-1 w-full p-2 border ${errors.password ? 'border-red-500' : 'border-gray-300'} rounded-md`}
                  {...register('password', { required: 'A senha é obrigatória', minLength: { value: 6, message: 'Mínimo 6 caracteres' } })}
                />
                {errors.password && <p className="text-sm text-red-600">{errors.password.message}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Confirme a senha</label>
                <input
                  type="password"
                  className={`mt-1 w-full p-2 border ${errors.confirmPassword ? 'border-red-500' : 'border-gray-300'} rounded-md`}
                  {...register('confirmPassword', {
                    required: 'Confirme a senha',
                    validate: v => v === password || 'As senhas não coincidem'
                  })}
                />
                {errors.confirmPassword && <p className="text-sm text-red-600">{errors.confirmPassword.message}</p>}
              </div>

              <button type="submit" disabled={isSubmitting} className="w-full py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700">
                Salvar nova senha
              </button>
            </form>

            <div className="mt-4 text-sm text-center">
              <Link to="/" className="text-blue-600">Voltar ao login</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
